import StyledWrapper, { getStyledWrapper } from "@insite/client-framework/Common/StyledWrapper";
import addDays from "@insite/client-framework/Common/Utilities/addDays";
import getFileExtension from "@insite/client-framework/Common/Utilities/getFileExtension";
import { makeHandlerChainAwaitable } from "@insite/client-framework/HandlerCreator";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import clearForm from "@insite/client-framework/Store/Components/ContactUsForm/Handlers/ClearForm";
import setIsBadFile from "@insite/client-framework/Store/Components/OrderUpload/Handlers/SetIsBadFile";
import setUploadLimitExceeded from "@insite/client-framework/Store/Components/OrderUpload/Handlers/SetUploadLimitExceeded";
import resetReCaptcha from "@insite/client-framework/Store/Components/ReCaptcha/Handlers/ResetReCaptcha";
import validateReCaptcha from "@insite/client-framework/Store/Components/ReCaptcha/Handlers/ValidateReCaptcha";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import DataTable, { DataTableProps } from "@insite/mobius/DataTable";
import DataTableBody, { DataTableBodyProps } from "@insite/mobius/DataTable/DataTableBody";
import DataTableCell from "@insite/mobius/DataTable/DataTableCell";
import { DataTableCellBaseProps } from "@insite/mobius/DataTable/DataTableCellBase";
import DataTableHead, { DataTableHeadProps } from "@insite/mobius/DataTable/DataTableHead";
import DataTableHeader, { DataTableHeaderProps } from "@insite/mobius/DataTable/DataTableHeader";
import DataTableRow, { DataTableRowProps } from "@insite/mobius/DataTable/DataTableRow";
import DatePicker, { DatePickerPresentationProps, DatePickerState } from "@insite/mobius/DatePicker";
import FileUpload, { FileUploadPresentationProps } from "@insite/mobius/FileUpload";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Hidden from "@insite/mobius/Hidden";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import AlertTriangle from "@insite/mobius/Icons/AlertTriangle";
import Link from "@insite/mobius/Link";
import Radio, { RadioComponentProps } from "@insite/mobius/Radio";
import RadioGroup, { RadioGroupComponentProps } from "@insite/mobius/RadioGroup";
import Select, { SelectPresentationProps } from "@insite/mobius/Select";
import TextArea, { TextAreaProps } from "@insite/mobius/TextArea";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import Typography, { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import FieldSetPresentationProps, { FieldSetGroupPresentationProps } from "@insite/mobius/utilities/fieldSetProps";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { RequestForQuoteFormModel } from "@tCooneyBrothers/ApiModels";
import { formatPhoneNumber } from "@tCooneyBrothers/Common/Utilities/formatPhoneNumber";
import { CallbackType, ErrorObjectType, InputObjectType, validate } from "@tCooneyBrothers/Common/Utilities/validate";
import CustomReCaptcha from "@tCooneyBrothers/Components/CustomCaptcha";
import {
    FormErrorsStateType,
    intialErrorFormState,
    requestForQuoteValidatorConfig,
    ValidatorConfigType,
} from "@tCooneyBrothers/Components/RequestForQuoteFormValidatorConfig";
import loadUserDetails from "@tCooneyBrothers/Handlers/LoadUserDetails";
import addRequestForQuoteFormFields from "@tCooneyBrothers/Handlers/RequestForQuoteFormHandler";
import CustomApplicationState from "@tCooneyBrothers/Store/CustomApplicationState";
import keyBy from "lodash/keyBy";
import * as React from "react";
import { useRef } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const enum fields {
    label = "label",
    hintText = "hintText",
    isRequired = "isRequired",
}


interface OwnProps extends WidgetProps {
    fields: {
        [fields.label]: string;
        [fields.hintText]: string;
        [fields.isRequired]: boolean;
    };
}

const mapStateToProps = (state: CustomApplicationState) => {
    return {
        sessionData: state.context?.session,
        userDatails: state.cbData.userDetails.value,
    };
};

const mapDispatchToProps = {
    addRequestForQuoteFormFields,
    loadUserDetails,
    resetReCaptcha,
    // eslint-disable-next-line @typescript-eslint/ban-types
    validateReCaptcha: makeHandlerChainAwaitable<{ location: string; recaptchaRef: React.RefObject<ReCAPTCHA> }, boolean>(
        validateReCaptcha,
    ),
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface RequestForQuoteFormStyles {
    formWrapper?: InjectableCss;
    mainGridContainer?: GridContainerProps;
    fullWidth?: InjectableCss;
    sectionHeading?: InjectableCss;
    userNameTextField?: TextFieldPresentationProps;
    customInputCss?: InjectableCss;
    submitGridItem?: GridItemProps;
    flexStart?: InjectableCss;
    alignButton?: InjectableCss;
    marginTop?: InjectableCss;
    submitButton?: ButtonPresentationProps;
    emailTextField?: TextFieldPresentationProps;
    fromDate?: DatePickerPresentationProps;
    startDatePicker?: DatePickerPresentationProps;
    textArea?: TextAreaProps;
    dataTable?: DataTableProps;
    dataTableRow?: DataTableRowProps;
    dataTableHead?: DataTableHeadProps;
    dataTableHeaders?: DataTableHeaderProps;
    dataTableBody?: DataTableBodyProps;
    dataTableCells?: DataTableCellBaseProps;
    rfqTableHeader?: DataTableHeaderProps;
    hintMessage?: InjectableCss;
    fileUploader?: FileUploadPresentationProps;
    addRemove?: InjectableCss;
    fileuploadStyle?: InjectableCss;
    fileUploadWrapper?: InjectableCss;
    fileUploadHint?: InjectableCss;
    tableWrapper?: InjectableCss;
    qntField?: InjectableCss;
    productFormMobileView?: InjectableCss;
    customWidthMobView?: InjectableCss;
    recaptchWrapper?: InjectableCss;
}

export const requestForQuoteFormStyles: RequestForQuoteFormStyles = {
    formWrapper: {
        css: css`
            margin-top: 20px;
            margin-bottom: 20px;
            h4 {
                font-weight: 600;
            }

            .requiredDateCss {
                > div > div > div {
                    margin-top: 13px !important;
                }
            }
            .fullWidthForMobileDevices {
                > div {
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                null,
                                null,
                                css`
                                    width: 100% !important;
                                `,
                            ],
                            "max",
                        )}
                }
            }
            > div[class^="GridWrapper"] {
                margin-top: 10px;
                padding-left: 0;
                margin-bottom: 30px;
                > div[class^="GridOffset"] {
                    width: 100%;
                    margin: 0;
                }
                > div[class^="RadioStyle"] {
                    margin-top: 0;
                    border: 1px solid red;
                    > label[class^="TypographyStyle"] {
                        font-size: 13px;
                    }
                }
            }
        `,
    },
    fullWidth: {
        css: css`
            width: 100%;
            > div[class^="RadioGroupStyle"] {
                justify-content: flex-start;
                display: inline-block;
                > div[class^="RadioStyle"] {
                    margin-top: 0;
                    margin-right: 20px;
                    display: inline-block;
                    &:last-child {
                        margin-rigte: 0;
                    }
                    > label[class^="TypographyStyle"] {
                        font-size: 13px;
                    }
                }
            }
        `,
    },
    sectionHeading: {
        css: css`
            font-weight: bold;
            border-bottom: 2px solid #ef3742;
            padding: 9px;
            padding-left: 15px;
            width: 100%;
            background: #f8f9fa;
            margin-bottom: 25px;
            margin-top: 25px;
        `,
    },
    customInputCss: {
        css: css`
            width: calc(33.3333% - 20px);
            display: inline-block;
            vertical-align: top;
            margin-bottom: 20px;
            margin-right: 30px;
            &:nth-child(3n + 1) {
                margin-right: 0;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            width: 100%;
                            margin-right: 0;
                        `,
                    ],
                    "max",
                )}

            > div[class^="FormFieldStyle"] {
                position: relative;
                width: 90%;
                > label {
                    font-size: 13px;
                    position: absolute;
                    z-index: 1;
                    padding-left: 5px;
                    background-color: #fff;
                    display: inline-block;
                    width: auto;
                    left: 20px;
                }
                > div input[type="text"] {
                    font-size: 13px;
                }
                > div select {
                    font-size: 13px;
                }
                > div[class^="FormInputWrapper"] {
                    > input {
                        font-size: 13px;
                    }
                    > div {
                        > span {
                            font-size: 13px;
                        }
                    }
                }
            }
            > div[class^="TooltipWrapper"] {
                width: 10%;
                padding: 10px;
            }
        `,
    },
    submitGridItem: {
        width: 12,
        css: css`
            justify-content: flex-end;
        `,
    },
    flexStart: {
        css: css`
            justify-content: flex-start;
        `,
    },
    alignButton: {
        css: css`
            text-align: center;
            width: 100%;
        `,
    },
    marginTop: {
        css: css`
            margin-top: 15px;
        `,
    },
    submitButton: {
        css: css`
            margin-right: 10px;
        `,
    },
    tableWrapper: {
        css: css`
            overflow: auto;
        `,
    },
    dataTableRow: {
        css: css`
            background: transparent !important;
        `,
    },
    rfqTableHeader: {
        css: css`
            border:;1px solid red;
            text-align:center;
        `,
    },
    hintMessage: {
        css: css`
            font-weight: normal;
            padding-left: 10px;
            font-size: 13px;
        `,
    },
    fileUploader: {
        buttonProps: {
            variant: "tertiary",
        },
    },
    addRemove: {
        css: css`
            text-align: right;
            margin-top: 30px;
        `,
    },
    fileUploadWrapper: {
        css: css`
            display: flex;
            align-items: flex-end;
            width: 100%;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            display: block;
                        `,
                    ],
                    "max",
                )}
        `,
    },
    fileUploadHint: {
        css: css`
            font-size: 12px;
        `,
    },
    fileuploadStyle: {
        css: css`
            position: relative;
            width: 50%;
            margin-right: 10px;
            margin-top: 10px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            width: 100%;
                            margin-right: 0px;
                            margin-bottom: 10px;
                        `,
                    ],
                    "max",
                )}
            >div[class^="UploadWrapper"] {
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                display: block;
                                > label[class^="ButtonWrapper"] {
                                    margin: 5px 0 0 0;
                                }
                            `,
                        ],
                        "max",
                    )}
            }
            > span[class^="TypographyStyle"] {
                position: absolute;
                left: 100px;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            null,
                            css`
                                position: relative;
                                left: 0;
                            `,
                        ],
                        "max",
                    )}
                font-size: 13px;
                padding-top: 4px;
            }
        `,
    },
    qntField: {
        css: css`
            [class^="FormInputWrapper"] {
                width: 80px;
            }
        `,
    },
    customWidthMobView: {
        css: css`
            div {
                width: 100% !important;
            }
        `,
    },
    productFormMobileView: {
        css: css`
            [class^="GridItemStyle"] {
                padding: 6px;
            }
            [class^="GridOffset"] {
                margin: 0;
            }
            padding: 15px;
            &:nth-child(odd) {
                background: #f3f3f3;
            }
        `,
    },
    recaptchWrapper: {
        css: css`
            margin-top: 15px;
        ` 
    }
};

interface RfqProduct {
    [x: string]: string | number | undefined;
    mpn?: string;
    mfrName?: string;
    quantity?: string;
    description?: string;
}

const styles = requestForQuoteFormStyles;
const emailRequiredFieldMessage = siteMessage("CreateNewAccountInfo_EmailAddress_Required");
const emailFieldMessage = siteMessage("CreateNewAccountInfo_EmailAddress_ValidEmail");
const emailRegexp = new RegExp("\\w+([-+.']\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*");

const RequestForQuoteForm: React.FC<Props> = ({
    sessionData,
    userDatails,
    addRequestForQuoteFormFields,
    loadUserDetails,
    validateReCaptcha,
    resetReCaptcha
}) => {
    const [firstName, setFirstName] = React.useState("");
    const [lastName, setLastName] = React.useState("");
    const [phone, setPhone] = React.useState<any>(null);
    const [isSubmitted, setIsSubmitted] = React.useState(false);
    const [emailError, setEmailError] = React.useState(emailRequiredFieldMessage);
    const [email, setEmail] = React.useState("");
    const [formErrors, setFormErrors] = React.useState<FormErrorsStateType>(intialErrorFormState);
    const [isButtonDisabled, setIsButtonDisabled] = React.useState(true);
    const [companyName, setCompanyName] = React.useState("");
    const [requireByDate, setRequireByDate] = React.useState<Date>(new Date());
    const [currentDate, setCurrentDate] = React.useState<Date>(new Date());
    const [rfqComments, setRfqComments] = React.useState("");
    const [products, setProducts] = React.useState(new Array<RfqProduct>(3));
    const [isProductArrayEmpty, setIsProductArrayEmpty] = React.useState(true);
    const fileUploadRef = useRef({ value: "" } as HTMLInputElement);
    const [incorrectFileExtension, setIncorrectFileExtension] = React.useState(false);
    const [file, setFile] = React.useState<any>(null);
    const recaptchaRef: React.RefObject<ReCAPTCHA> = React.createRef();

    React.useEffect(() => {
        if (sessionData.isAuthenticated) {
            const firstName = sessionData.firstName;
            const lastName = sessionData.lastName;
            const email = sessionData.email;
            setFirstName(firstName);
            setLastName(lastName);
            setEmail(email);
            loadUserDetails();
        }
    }, []);

    React.useEffect(() => {
        if (sessionData.isAuthenticated && userDatails && userDatails.length > 0) {
            setCompanyName(userDatails[0].companyName);
        }
    }, [userDatails]);

    React.useEffect(() => {
        const firstNameSelector: HTMLInputElement | null = document.querySelector('[name="firstName"]');
        if (sessionData.isAuthenticated && firstNameSelector) {
            validateHandler(firstNameSelector);
        }
    }, [firstName]);

    React.useEffect(() => {
        const lastNameSelector: HTMLInputElement | null = document.querySelector('[name="lastName"]');
        if (sessionData.isAuthenticated && lastNameSelector) {
            validateHandler(lastNameSelector);
        }
    }, [lastName]);

    React.useEffect(() => {
        const emailSelector: HTMLInputElement | null = document.querySelector('[name="email"]');
        if (sessionData.isAuthenticated && emailSelector) {
            validateEmail(emailSelector.value);
            validateHandler(emailSelector);
        }
    }, [email]);

    if (isProductArrayEmpty) {
        for (let i = 0; i < products.length; i++) {
            products[i] = {};
        }
        setIsProductArrayEmpty(false);
    }

    const firstNameChangeHandler = (input: HTMLInputElement) => {
        setFirstName(input.value);
        validateHandler(input);
    };
    const lastNameChangeHandler = (input: HTMLInputElement) => {
        setLastName(input.value);
        validateHandler(input);
    };
    const phoneChangeHandler = (input: HTMLInputElement) => {
        setPhone(formatPhoneNumber(input.value));
        validateHandler(input);
    };
    const emailChangeHandler = (input: HTMLInputElement) => {
        validateEmail(input.value);
        setEmail(input.value);
        validateHandler(input);
    };
    const validateEmail = (email: string) => {
        const errorMessage = !email ? emailRequiredFieldMessage : emailRegexp.test(email) ? "" : emailFieldMessage;
        setEmailError(errorMessage);
        return !errorMessage;
    };
    const companyNameHandler = (cName: string) => {
        setCompanyName(cName);
    };
    const requireByDateHandler = ({ selectedDay }: DatePickerState) => {
        setRequireByDate(selectedDay || new Date());
    };
    const commentsChangeHandler = (input: HTMLTextAreaElement) => {
        setRfqComments(input.value);
    };

    const validateHandler = (input: HTMLInputElement | HTMLSelectElement, customValidation?: CallbackType): void => {
        const inputObject: InputObjectType = {
            name: input.name,
            value: input.value,
        };
        const validatorConfig = requestForQuoteValidatorConfig[input.name as keyof ValidatorConfigType];
        const isValidate: ErrorObjectType | undefined = validate(inputObject, validatorConfig, customValidation);

        if (isValidate === undefined) {
            delete formErrors[input.name as keyof FormErrorsStateType];
            setFormErrors(formErrors);
        } else {
            setFormErrors({
                ...formErrors,
                [input.name]: isValidate ? isValidate.errorMsg : isValidate,
            });
        }
        if (!validatorConfig.required && input.value === "") {
            delete formErrors[input.name as keyof FormErrorsStateType];
            setFormErrors(formErrors);
        }
        setIsButtonDisabled(validateSubmitDisabled(formErrors));
    };
    const submitHandler = async (event: React.MouseEvent<HTMLButtonElement>) => {
        if (!isSubmitted) {
            setIsSubmitted(true);
        }
        const isReCaptchaValid = await validateReCaptcha({ location: "request-for-quote", recaptchaRef });
        if (!isReCaptchaValid) {
            return;
        }
        // Datepicker string
        const year = requireByDate.getFullYear();
        let month = (1 + requireByDate.getMonth()).toString();
        month = month.length > 1 ? month : `0${month}`;
        let day = requireByDate.getDate().toString();
        day = day.length > 1 ? day : `0${day}`;
        const updatedRequireByDate = `${month}/${day}/${year}`;
        const rfqForm: RequestForQuoteFormModel = {
            rfqrequest: {
                firstName,
                lastName,
                phone,
                company: companyName,
                emailAddress: email,
                requireByDate: updatedRequireByDate,
                comments: rfqComments,
                productList: products,
            },
            attachment: {
                attachment: file,
            },
        };

        addRequestForQuoteFormFields({
            rfqForm,
            onSuccess: () => {
                const dataLayer = (window as any).dataLayer || [];
                if (dataLayer) {
                    dataLayer.push({ ecommerce: null });
                    dataLayer.push({
                        event: "request_for_quote",
                    });
                }
                clearForm();
                window.location.href = "/ThankYou";
            },
        });
    };

    const validateSubmitDisabled = (errorsState: FormErrorsStateType) => {
        return Object.keys(errorsState).length !== 0;
    };

    const fileChangeHandler = (event: React.ChangeEvent<any>) => {
        const uploadedFile = event.target.files[0];
        setFile(uploadedFile);
        if (uploadedFile) {
            const fileExtension = getFileExtension(uploadedFile.name);
            const incorrectFileExtension =
                ["xls", "xlsx", "csv", "png", "jpg", "docx", "doc", "pdf"].indexOf(fileExtension) === -1;
            setIncorrectFileExtension(incorrectFileExtension);
            setIsBadFile({ isBadFile: incorrectFileExtension });
            setUploadLimitExceeded({ uploadLimitExceeded: false });
        }
    };

    const addRow = () => {
        const obj: RfqProduct = {};
        setProducts([...products, obj]);
    };

    const removeRow = () => {
        setProducts(products => {
            const index = products.length - 1;
            if (index > 2) {
                const productsG = products.filter((item, j) => index !== j);
                return productsG;
            }
            return products;
        });
    };

    const updateProducts = (input: HTMLInputElement, key: any) => {
        const productsCopy = [...products];
        productsCopy[key][input.name] = input.value;
        setProducts(productsCopy);
    };
    return (
        <StyledWrapper {...styles.formWrapper}>
            <Typography as="p">
                Fill out our RFQ form below and one of our knowledgeable sales representatives will contact you with
                pricing and availibility. We generally respond within 1 to 3 hours during our business day(Monday -
                Friday, 8am-5pm ET).
            </Typography>
            <Typography as="p">
                If you are unsure of a part number or have other requests such as a customized product, please let us
                know in the 'comments' field. We look forward to meeting your PVF needs.
            </Typography>
            <GridContainer {...styles.mainGridContainer}>
                <StyledWrapper {...styles.fullWidth}>
                    <form autoComplete="off">
                        <StyledWrapper {...styles.sectionHeading}>Contact Information</StyledWrapper>
                        <StyledWrapper {...styles.customInputCss} className="fullWidthForMobileDevices">
                            <TextField
                                {...styles.userNameTextField}
                                label={translate("First Name")}
                                value={firstName}
                                data-test-selector="rfq_firstName"
                                onChange={e => firstNameChangeHandler(e.currentTarget)}
                                onBlur={e => validateHandler(e.currentTarget)}
                                error={!!formErrors.firstName && formErrors.firstName}
                                name="firstName"
                                iconProps={{ color: "danger", src: formErrors.firstName ? AlertTriangle : undefined }}
                                required
                            />
                        </StyledWrapper>
                        <StyledWrapper {...styles.customInputCss} className="fullWidthForMobileDevices">
                            <TextField
                                {...styles.userNameTextField}
                                label={translate("Last Name")}
                                value={lastName}
                                data-test-selector="rfq_lastName"
                                onChange={e => lastNameChangeHandler(e.currentTarget)}
                                onBlur={e => validateHandler(e.currentTarget)}
                                error={!!formErrors.lastName && formErrors.lastName}
                                name="lastName"
                                iconProps={{ color: "danger", src: formErrors.lastName ? AlertTriangle : undefined }}
                                required
                            />
                        </StyledWrapper>
                        <StyledWrapper {...styles.customInputCss} className="fullWidthForMobileDevices">
                            <TextField
                                {...styles.userNameTextField}
                                type="tel"
                                list="autocompleteOff"
                                autoComplete="new-password"
                                aria-autocomplete="none"
                                label={translate("Phone")}
                                value={phone}
                                data-test-selector="rfq_phone"
                                onChange={e => phoneChangeHandler(e.currentTarget)}
                                onBlur={e => validateHandler(e.currentTarget)}
                                error={!!formErrors.phone && formErrors.phone}
                                name="phone"
                                iconProps={{ color: "danger", src: formErrors.phone ? AlertTriangle : undefined }}
                            />
                        </StyledWrapper>
                        <StyledWrapper {...styles.customInputCss} className="fullWidthForMobileDevices">
                            <TextField
                                {...styles.emailTextField}
                                type="email"
                                label={translate("Email Address")}
                                onChange={e => emailChangeHandler(e.currentTarget)}
                                value={email}
                                data-test-selector="rfq_email"
                                required
                                onBlur={e => validateHandler(e.currentTarget)}
                                error={!!formErrors.email && formErrors.email}
                                name="email"
                                iconProps={{ color: "danger", src: formErrors.email ? AlertTriangle : undefined }}
                            />
                        </StyledWrapper>
                        <StyledWrapper {...styles.customInputCss} className="fullWidthForMobileDevices">
                            <TextField
                                label={translate("Company Name")}
                                value={companyName}
                                data-test-selector="rfq_companyName"
                                onChange={e => companyNameHandler(e.currentTarget.value)}
                                error={isSubmitted}
                            />
                        </StyledWrapper>
                        <StyledWrapper {...styles.customInputCss} className="fullWidthForMobileDevices requiredDateCss">
                            <DatePicker
                                {...styles.startDatePicker}
                                label={translate("Required By Date")}
                                selectedDay={requireByDate}
                                dateTimePickerProps={{
                                    minDate: currentDate,
                                    maxDate: undefined,
                                }}
                                onDayChange={requireByDateHandler}
                            />
                        </StyledWrapper>
                        <StyledWrapper {...styles.customInputCss} className="fullWidthForMobileDevices">
                            <TextArea
                                {...styles.textArea}
                                label={translate("Comments")}
                                value={rfqComments}
                                data-test-selector="rfq_comments"
                                onChange={e => commentsChangeHandler(e.currentTarget)}
                            />
                        </StyledWrapper>
                    </form>
                </StyledWrapper>

                <StyledWrapper {...styles.fullWidth}>
                    <StyledWrapper {...styles.sectionHeading}>
                        Product Information{" "}
                        <Typography as="span" {...styles.hintMessage}>
                            Please fill in as much information as you have for quoting purposes. You also have the
                            option to upload a file.
                        </Typography>
                    </StyledWrapper>
                    <StyledWrapper {...styles.tableWrapper}>
                        <Hidden below="lg">
                            <DataTable {...styles.dataTable}>
                                <DataTableHead {...styles.dataTableHead}>
                                    <DataTableHeader tight {...styles.rfqTableHeader}>
                                        {translate("Manufacturer Part Number")}
                                    </DataTableHeader>
                                    <DataTableHeader tight {...styles.rfqTableHeader}>
                                        {translate("Brand / MFR Name")}
                                    </DataTableHeader>
                                    <DataTableHeader tight {...styles.rfqTableHeader}>
                                        {translate("Quantity")}
                                    </DataTableHeader>
                                    <DataTableHeader tight {...styles.rfqTableHeader}>
                                        {translate("Short Description")}
                                    </DataTableHeader>
                                </DataTableHead>
                                <DataTableBody {...styles.dataTableBody}>
                                    {products.map((product, key) => (
                                        <DataTableRow
                                            {...styles.dataTableRow}
                                            data-test-selector="invoiceHistory_invoiceLine"
                                            key={product.key}
                                        >
                                            <DataTableCell>
                                                <TextField
                                                    value={product.mpn}
                                                    data-test-selector="rfq_companyName"
                                                    onChange={e => updateProducts(e.currentTarget, key)}
                                                    name="mpn"
                                                />
                                            </DataTableCell>
                                            <DataTableCell>
                                                <TextField
                                                    value={product.mfrName}
                                                    data-test-selector="rfq_companyName"
                                                    onChange={e => updateProducts(e.currentTarget, key)}
                                                    name="mfrName"
                                                />
                                            </DataTableCell>
                                            <DataTableCell>
                                                <TextField
                                                    type="number"
                                                    value={product.quantity}
                                                    data-test-selector="rfq_companyName"
                                                    onChange={e => updateProducts(e.currentTarget, key)}
                                                    name="quantity"
                                                />
                                            </DataTableCell>
                                            <DataTableCell>
                                                <TextField
                                                    value={product.description}
                                                    data-test-selector="rfq_companyName"
                                                    onChange={e => updateProducts(e.currentTarget, key)}
                                                    name="description"
                                                />
                                            </DataTableCell>
                                        </DataTableRow>
                                    ))}
                                </DataTableBody>
                            </DataTable>
                        </Hidden>
                        <Hidden above="md">
                            {products.map((product, key) => (
                                <>
                                    <StyledWrapper {...styles.productFormMobileView}>
                                        <GridContainer {...styles.customWidthMobView}>
                                            <GridItem width={6}>
                                                <Typography as="h4">{translate("Manufacturer Part Number")}</Typography>
                                            </GridItem>
                                            <GridItem width={6}>
                                                <TextField
                                                    value={product.mpn}
                                                    data-test-selector="rfq_companyName"
                                                    onChange={e => updateProducts(e.currentTarget, key)}
                                                    name="mpn"
                                                />
                                            </GridItem>
                                        </GridContainer>
                                        <GridContainer {...styles.customWidthMobView}>
                                            <GridItem width={6}>
                                                <Typography as="h4">{translate("Brand / MFR Name")}</Typography>
                                            </GridItem>
                                            <GridItem width={6}>
                                                <TextField
                                                    value={product.mfrName}
                                                    data-test-selector="rfq_companyName"
                                                    onChange={e => updateProducts(e.currentTarget, key)}
                                                    name="mfrName"
                                                />
                                            </GridItem>
                                        </GridContainer>
                                        <GridContainer {...styles.customWidthMobView}>
                                            <GridItem width={6}>
                                                <Typography as="h4">{translate("Quantity")}</Typography>
                                            </GridItem>
                                            <GridItem width={6} {...styles.qntField}>
                                                <TextField
                                                    type="number"
                                                    value={product.quantity}
                                                    data-test-selector="rfq_companyName"
                                                    onChange={e => updateProducts(e.currentTarget, key)}
                                                    name="quantity"
                                                />
                                            </GridItem>
                                        </GridContainer>
                                        <GridContainer {...styles.customWidthMobView}>
                                            <GridItem width={6}>
                                                <Typography as="h4">{translate("Short Description")}</Typography>
                                            </GridItem>
                                            <GridItem width={6}>
                                                <TextField
                                                    value={product.description}
                                                    data-test-selector="rfq_companyName"
                                                    onChange={e => updateProducts(e.currentTarget, key)}
                                                    name="description"
                                                />
                                            </GridItem>
                                        </GridContainer>
                                    </StyledWrapper>
                                </>
                            ))}
                        </Hidden>
                    </StyledWrapper>
                </StyledWrapper>
                <StyledWrapper {...styles.addRemove}>
                    <Button {...styles.submitButton} onClick={addRow} data-test-selector="rfq_addRow">
                        {translate("Add Row")}
                    </Button>
                    {products.length !== 3 && (
                        <Button {...styles.submitButton} onClick={removeRow} data-test-selector="rfq_removeRow">
                            {translate("Remove Row")}
                        </Button>
                    )}
                </StyledWrapper>
                <StyledWrapper {...styles.fileUploadWrapper}>
                    <StyledWrapper {...styles.fileuploadStyle}>
                        <FileUpload
                            {...styles.fileUploader}
                            inputRef={fileUploadRef}
                            fileName={file?.name || ""}
                            accept=".xls,.xlsx,.csv,.docx,.doc,.pdf,.jpg,.png"
                            label={translate("Upload a File")}
                            labelPosition="top"
                            error={incorrectFileExtension ? translate("must be .xls, .xlsx or .csv") : undefined}
                            onFileChange={fileChangeHandler}
                            uid="orderUploadFileUpload"
                        />
                    </StyledWrapper>
                    <StyledWrapper {...styles.fileUploadHint}>
                        <Typography as="span">
                            {translate(
                                "Most Excel file types (xslx, xls, csv, etc), Word documents (docx, doc, etc), PDFs, and image file types (jpg, png, etc) are accepted",
                            )}
                        </Typography>
                    </StyledWrapper>
                </StyledWrapper>
            </GridContainer>
            <StyledWrapper {...styles.recaptchWrapper}>
                <CustomReCaptcha recaptchaRef={recaptchaRef} location="request-for-quote" />
            </StyledWrapper>
            <StyledWrapper {...styles.submitGridItem} {...styles.flexStart} {...styles.alignButton}>
                <Button
                    {...styles.submitButton}
                    onClick={submitHandler}
                    disabled={isButtonDisabled}
                    data-test-selector="createAccount_createButton"
                >
                    {translate("Submit Quote Request")}
                </Button>
            </StyledWrapper>
        </StyledWrapper>
    );
};
const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(RequestForQuoteForm),
    definition: {
        group: "Contact Us",
        icon: "FormField",
        fieldDefinitions: [],
    },
};
export default widgetModule;
